<script src="//unpkg.com/vue/dist/vue.js"></script>
<script src="//unpkg.com/viewerjs/dist/viewer.js"></script>
<script src="//unpkg.com/v-viewer/dist/v-viewer.js"></script>

<template>
    <v-container>
        <div>
            <v-row justify="center" no-gutters>
                <v-col cols="12" sm="3" class="pr-3">
                    <v-autocomplete v-model="selectFormStyle" :items="formStyles" item-text="name" v-bind:label="$t('design_item.form_style')" outlined return-object dense background-color="#ffffff"></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="4" class="pr-3">
                    <v-autocomplete v-model="selectMaterialStyle" :items="materialStyles" item-text="displayString" v-bind:label="$t('design_item.material_style')" outlined return-object dense background-color="#ffffff"></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="4" class="pr-3">
                    <v-autocomplete v-model="selectCustomerType" :items="customerTypes" item-text="name" v-bind:label="$t('customer_type.title')" outlined return-object dense background-color="#ffffff"></v-autocomplete>
                </v-col>
                
                <v-col cols="12" sm=1>
                    <v-btn dark color="primary" @click="getData(true)"> Tìm ảnh </v-btn>
                </v-col>
            </v-row>
        </div>
        
        <viewer :images="images" :options="options">
            <img v-for="(image, index) in images" :src="image.thumbnail" :data-src="image.source" :key="index" class="image">
        </viewer>

        <!-- <div v-viewer="options" class="images">
            <template v-for="(image,index) in images">
                <img 
                    :src="image.thumbnail" class="image" :key="index"
                    :data-src="image.source"
                >
            </template>
        </div> -->

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <div class="text-center pt-2">
          <v-btn color="primary" @click="nextPage"> Tải thêm </v-btn>
        </div>
    </v-container>
</template>

<script>
  import 'viewerjs/dist/viewer.css'
//   import Viewer from 'v-viewer'
//   import Vue from 'vue'
//   Vue.use(Viewer)

  import i18n from '@/plugins/i18n';
//   import moment from 'moment';
//   import ManufactureRequestDialog from "@/components/ManufactureRequestDialog";

  export default {
    data: () => ({
        baseImage: process.env.VUE_APP_BASE_IMAGE,
        baseAttach: process.env.VUE_APP_BASE_ATTACH,

        overlay: false,
        limit: 18,
        page: 0,

        selectFormStyle: {},
        formStyles: [],
        
        selectMaterialStyle: {},
        materialStyles:[],

        selectCustomerType: {},
        customerTypes: [],
        
        desserts: [],
        images: [],
        options: {
            url: 'data-src'
        }
    }),

    async created () {
    //   this.getData();
        await Promise.all([
            this.getCustomerTypes(),
            this.getFormStyles(),
            this.getMaterialStyles()
        ]);

        this.getData(true);
    },

    methods: {
        initialize () {
        },

        nextPage() {
            this.page = this.page + 1;
            this.getData(false);
        },

        toggle() {

        },

        async getData(refresh) {
            if (refresh) {
                this.desserts = [];
                this.page = 0;
                this.images = [];
            }

            const self = this;
            self.overlay = true;

            try {
                let request = '/manufactureRequestDetail' + '?limit=' + this.limit + '&skip=' + this.page * this.limit;
                if (self.selectFormStyle._id != -1) {
                    request = request + '&formStyleId=' + self.selectFormStyle._id;
                }

                if (self.selectMaterialStyle._id != -1) {
                    request = request + '&materialStyleId=' + self.selectMaterialStyle._id;
                }

                const response = await this.$http.get(request);
                self.overlay = false;
                
                if (response.data && response.data.success) {
                    // self.desserts = self.desserts.concat(response.data.data);
                    self.images = self.images.concat(self.createListImages(response.data.data));
                }
                
            } catch (e) {
                console.log(e.stack);
            }
        },

        createListImages(arrayData) {
            let results = [];
            arrayData.forEach(requestDetail => {
                results = results.concat(this.getImagePath(requestDetail));

            });
            
            return results;
        },

        checkHasImage(requestDetail) {
            if (requestDetail.files.length > 0) {
                return true;
            }
            return false;
        },
        
        getImagePath(requestDetail) {
            let urls = [];
            if (requestDetail.files.length > 0) {
                // return this.baseAttach + requestDetail.files[0]._id;
                requestDetail.files.forEach(element => {
                    urls.push( 
                        {
                            thumbnail: this.baseAttach + element._id + "/0/200",
                            source: this.baseAttach + element._id
                        }
                    );
                });
            }
            return urls;
        },

        async getFormStyles() {
            try {
                const response = await this.$http.get('/formStyle');
                if (response.data && response.data.success) {
                    const optionAll = {
                        name : "Tất cả",
                        _id : "-1"
                    }

                    this.formStyles = [optionAll].concat(response.data.data);
                    this.selectFormStyle = optionAll;
                } else if(response.data && !response.data.success) {
                    alert(i18n.t(response.data.message));
                } else {
                    alert(i18n.t('validate.request_error'));
                }  
            } catch (e) {
                console.log(e.stack);
                alert(i18n.t('validate.request_error'));
            }
        },

        async getMaterialStyles() {
            try {
                const response = await this.$http.get('/materialStyle');
                if (response.data && response.data.success) {

                    this.materialStyles = response.data.data;
                    if (this.materialStyles.length > 0) {
                        this.materialStyles.forEach(item => {
                            item.displayString = this.createMaterialStyleString(item);
                        });

                        

                        const optionAll = {
                            displayString : "Tất cả",
                            _id : "-1"
                        }
                        this.materialStyles = [optionAll].concat(this.materialStyles);
                        this.selectMaterialStyle = optionAll;
                    }
                }
            } catch (e) {
                console.log(e.stack);
            }
        },
        createMaterialStyleString(detail) {
            if (!detail) {
                return '--';
            }
            return detail.material.name + " - " + detail.color_name + ' (' + detail.code + ')';
        },

        async getCustomerTypes() {
            try {
                const response = await this.$http.get(process.env.VUE_APP_CUSTOMER_TYPE_API);
                if (response.data && response.data.success) {
                    const optionAll = {
                        name : "Tất cả",
                        _id : "-1"
                    }

                    this.customerTypes = [optionAll].concat(response.data.data);
                    this.selectCustomerType = optionAll;
                }
            } catch (e) {
                console.log(e.stack);
            }
        }
    }
  }
</script>

<style scoped>
.image {
  height: 200px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
</style>